import { Outlet } from "react-router";
import { Toaster } from "@dg/ui";
import { LoadingBar } from "./loading-bar.js";
import { Nav } from "./nav.js";

export function RootLayout() {
  return (
    <div className="min-h-screen text-foreground">
      <div className="bg-glow bg-glow-1" />
      <div className="bg-glow bg-glow-2" />
      <LoadingBar />
      <Nav />
      <main className="relative mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <Outlet />
      </main>
      <Toaster />
    </div>
  );
}
